import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { roundPlaceholder } from '@mage-ui/styled-system/recipes';

export const RoundPlaceholder = ({ className, texts }) => {
  return (
    <span
      role='img'
      aria-label={texts.a11yText}
      className={cx(roundPlaceholder().root, className)}
    >
      <Icon
        name='no_photography'
        className={roundPlaceholder().icon}
        aria-hidden='true'
      />
    </span>
  );
};
